export default "__VITE_ASSET___HO9b$ON__"